import { useMemo } from 'react'
import { CustomTable, TableEmptyState } from 'app/components'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { TelekitList } from '../core/_models'
import { TelekitsColumns } from './columns/_columns'
import { useT } from '_metronic/i18n/Metronici18n'

export const TelekitsTable = () => {
  const { response, isLoading, isError, refetch } = useQueryResponse()
  const { hasFilters, clearFilters } = useListFilters()
  const { t } = useT()
  const mostrarRegime = (response?.data ?? []).some((telekit) => telekit.regime === 'VENDIDO')
  const columns = useMemo(() => TelekitsColumns(t, { mostrarRegime }), [t, mostrarRegime])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title='Nenhum telekit encontrado'
      description={`Revise a ${t('empresa.label.lowercase')} ou a situação selecionada.`}
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhum telekit cadastrado'
      description='Use “Adicionar” para cadastrar o primeiro telekit.'
    />
  )

  return (
    <CustomTable<TelekitList>
      id='kt_table_telekits'
      ariaLabel={t('menu.telekits')}
      itemLabel={{ singular: 'telekit', plural: 'telekits' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
